import { render, staticRenderFns } from "./file-uploader.vue?vue&type=template&id=fd45fe74"
import script from "./file-uploader.ts?vue&type=script&lang=js&external"
export * from "./file-uploader.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports